module.exports = __webpack_public_path__ + "static/media/septic_sewag.ba86185b.svg";